import { useCallback, useRef, useState } from "react";

/**
 * Executa as gravações uma de cada vez, na ordem em que foram pedidas. Sem
 * isso, dois PATCHes seguidos (sair de um campo e clicar em outro) chegam ao
 * servidor em qualquer ordem e a resposta mais velha sobrescreve a nova no
 * cache. `aguardar` deixa quem gera o documento esperar a fila esvaziar.
 */
export function useFilaDeSalvamento() {
  const fila = useRef<Promise<unknown>>(Promise.resolve());
  const [pendentes, setPendentes] = useState(0);
  const [ultimaGravacao, setUltimaGravacao] = useState<Date | null>(null);

  const enfileirar = useCallback(<T,>(tarefa: () => Promise<T>): Promise<T> => {
    setPendentes((total) => total + 1);
    const execucao = fila.current.then(tarefa);
    fila.current = execucao
      .then(
        () => setUltimaGravacao(new Date()),
        () => undefined,
      )
      .finally(() => setPendentes((total) => total - 1));
    return execucao;
  }, []);

  const aguardar = useCallback(() => fila.current, []);

  return { enfileirar, aguardar, salvando: pendentes > 0, ultimaGravacao };
}
